import MUIDivider from '@mui/material/Divider'
import PropTypes from 'prop-types'
import React from 'react'

const Divider = ({ orientation }) => <MUIDivider orientation={orientation} component="hr" />

Divider.propTypes = {
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
}

Divider.defaultProps = {
  orientation: 'horizontal',
}

export default Divider
